import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ArrowIcon from '@mui/icons-material/ArrowForwardOutlined';
import { SECCIONES_VOZ } from '../config/rayos';
import './cabecera-seccion.css';

/**
 * LA CABECERA DE LAS TRES SECCIONES DE VOCES.
 *
 * Faina, 26-ago: «¿por qué Trabajadores de la Luz no tiene la misma entrada que
 * Esenios y Ángeles y Arcángeles?». Tenía razón: eran tres páginas hermanas con
 * tres cabeceras distintas, y eso se lee como descuido.
 *
 * ⭐ PERO LA DIFERENCIA EXISTE, Y EN VEZ DE ESCONDERLA LA DICE EL RÓTULO:
 *
 *     Esenios                 →  QUIÉN TE HABLA
 *     Ángeles y Arcángeles    →  QUIÉN TE HABLA
 *     Trabajadores de la Luz  →  A QUIÉN LE HABLAN
 *
 * Dos palabras, y queda explicado que los primeros son voces y los terceros un
 * destinatario. Misma entrada, misma tipografía, mismo aire — y la única
 * diferencia es la que de verdad importa.
 *
 * Debajo, LAS HERMANAS: las tres se enlazan entre sí, porque quien entra por una
 * no tiene forma de saber que existen las otras dos.
 */

/* El rotulo es OPCIONAL: en La Fundacion el titulo es el nombre y no hace falta
   anunciarlo, y su «quienes somos» vive en el primer bloque, junto al parrafo
   que lo responde. */
const CabeceraSeccion = ({ rotulo, titulo, bajada, hermanas = [], marca = false, logo = null, seccion = null }) => {
  const { t } = useTranslation();
  return (
  <Box className="cab">
    <Container maxWidth="lg">
      <Box className="cab-texto">
        {rotulo && <Typography className="cab-rotulo">{rotulo}</Typography>}
        {/* `marca`: el titulo ES el nombre de la Fundacion, asi que lleva su
            naranja y el logo delante. Solo para esa pagina — en las de voces el
            titulo va en blanco y el color lo pone el rayo de la entidad. */}
        {/* Con `seccion` NO hay titulo aparte (Faina, 26-ago: «sacaría Esenios
            en blanco y dejaría Esenios abajo en naranja, con letra más
            grande»). Decirlo dos veces —una en blanco arriba y otra en naranja
            debajo— era repetirse; el activo de las tres hace de titulo. */}
        {!seccion && (
          <Typography variant="h1" className={`cab-h1${marca ? ' cab-h1-marca' : ''}`}>
            {marca && logo && <Box component="img" src={logo} alt="" className="cab-logo" />}
            {titulo}
          </Typography>
        )}
        {/* Solo si la hay: sin condicion se pintaba un parrafo vacio que
            dejaba un hueco bajo el titulo en las tres secciones de voces. */}
        {bajada && <Typography className="cab-bajada">{bajada}</Typography>}
      </Box>

      {/* 🔴 LA MISMA COMPOSICION EN LAS TRES (Faina, 26-ago: «ninguna de las
          tres paginas esta igual en la parte de arriba»).

          Estaban las tres en una sola linea, y como el activo es mucho mas
          grande y cada nombre mide distinto, el bloque se descolocaba de una
          manera en cada pagina: en Esenios el activo caia al centro, en Angeles
          al final, y en Trabajadores —el nombre mas largo— empujaba «Angeles y
          Arcangeles» a una segunda linea.

          Ahora la estructura es FIJA y no depende del largo de los nombres:
          el activo solo, centrado, haciendo de titulo; y debajo las otras dos.
          Las tres paginas entran identicas. */}
      {seccion && (
        <>
          <Typography component="h1" className="cab-familia-aqui">
            {t(SECCIONES_VOZ.find((s) => s.clave === seccion).titulo)}
          </Typography>

          <Box className="cab-familias" role="navigation" aria-label={t('cabecera.otras')}>
            {SECCIONES_VOZ.filter((s) => s.clave !== seccion).map((s) => (
              <RouterLink key={s.clave} to={s.ruta} className="cab-familia">
                {t(s.titulo)}
              </RouterLink>
            ))}
          </Box>
        </>
      )}

      {/* Compatibilidad: la forma anterior sigue funcionando donde no se pase
          `seccion`. */}
      {!seccion && hermanas.length > 0 && (
        <Box className="cab-hermanas">
          {hermanas.map((h) => (
            <RouterLink key={h.ruta} to={h.ruta} className="cab-hermana">
              {t(h.titulo)} <ArrowIcon fontSize="inherit" />
            </RouterLink>
          ))}
        </Box>
      )}
    </Container>
  </Box>
  );
};

export default CabeceraSeccion;
